export const DUPLICATE_RESPONSE_CODE = 'restricted_business_name';

export const COMPLETED_STATUS_CODE = 'complete';

export const REQUIRED_OUTPUT_VARIABLES = [
  {
    name: 'business_usecase',
    is_required: true,
    is_multiple: false,
  },
  {
    name: 'app_requirements',
    is_required: true,
    is_multiple: false,
  },
  {
    name: 'strategic_plan',
    is_required: true,
    is_multiple: false,
  },
];

export const MAX_RETRY_MS = 30000;

export const RETRY_INTERVAL = 100;
